import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BrowserPlatformService {
  constructor(@Inject(DOCUMENT) readonly document: Document) {}

  get window(): Window {
    return this.document.defaultView as Window;
  }

  get location(): Location {
    return this.window.location;
  }

  get navigator(): Navigator {
    return this.window.navigator;
  }

  get screen(): Screen {
    return this.window.screen;
  }

  get sessionStorage(): Storage {
    return this.window.sessionStorage;
  }

  get cookie(): string {
    return this.document.cookie;
  }

  set cookie(value: string) {
    this.document.cookie = value;
  }

  navigateExternal(url: string): void {
    this.location.href = url;
  }
}
